<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="main-part">
            <div class="page-inner">
            <div class="table-container">
                <table class="price-table">
                    <thead>
                        <tr>
                            <th>{{ $t('name') }}</th>
                            <th>{{ $t('price') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in priceList" :key="item.name">
                            <td>{{ item.name }}</td>
                            <td>{{ formatNumber(item.price) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "../../common/Breadcrumb.vue";
import { watch } from "vue";

export default {
    data() {
        return {
            priceList: [
               {
                    "id": 1,
                    "name": this.$t('priceListItem1'),
                    "price": 70,
                },
                {
                    "id": 1,
                    "name": this.$t('priceListItem2'),
                    "price": 50,
                },
                {
                    "id": 3,
                    "name": this.$t('priceListItem3'),
                    "price": 170,
                },
                {
                    "id": 4,
                    "name": this.$t('priceListItem4'),
                    "price": 120,
                },
                {
                    "id": 5,
                    "name": this.$t('priceListItem5'),
                    "price": 90,
                },
                {
                    "id": 6,
                    "name": this.$t('priceListItem6'),
                    "price": 70,
                },
                {
                    "id": 7,
                    "name": this.$t('priceListItem7'),
                    "price": 100,
                },
                {
                    "id": 8,
                    "name": this.$t('priceListItem8'),
                    "price": 70,
                },
                {
                    "id": 9,
                    "name": this.$t('priceListItem9'),
                    "price": 70,
                },
            ]
        }
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
    methods: {
        loadItems(){
            this.priceList = [
                {
                    "id": 1,
                    "name": this.$t('priceListItem1'),
                    "price": 70,
                },
                {
                    "id": 1,
                    "name": this.$t('priceListItem2'),
                    "price": 50,
                },
                {
                    "id": 3,
                    "name": this.$t('priceListItem3'),
                    "price": 170,
                },
                {
                    "id": 4,
                    "name": this.$t('priceListItem4'),
                    "price": 120,
                },
                {
                    "id": 5,
                    "name": this.$t('priceListItem5'),
                    "price": 90,
                },
                {
                    "id": 6,
                    "name": this.$t('priceListItem6'),
                    "price": 70,
                },
                {
                    "id": 7,
                    "name": this.$t('priceListItem7'),
                    "price": 100,
                },
                {
                    "id": 8,
                    "name": this.$t('priceListItem8'),
                    "price": 70,
                },
                {
                    "id": 9,
                    "name": this.$t('priceListItem9'),
                    "price": 70,
                },
            ]
        },
        formatNumber(value) {
            const code = this.getSelectedLanguage.code;
            const number = Number(value);
            if (isNaN(number)) return '-';
            if (code === 'bs' || code === 'hr') {
                return number.toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            } else {
                return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },
    },
    computed: {
        ...mapGetters(["getContentById", "getSelectedLanguage", "getContentByUrl"]),
    },
    created() {
    },
    watch:{
        getSelectedLanguage(){
            this.loadItems();
        }
    }


}
</script>

<style scoped>
.table-container {
    margin: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.price-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
}

.price-table th {
    /* background: #1e3266; */
    background: var(--main-color);
    color: white;
    text-align: left;
    padding: 12px 20px;
    font-weight: 500;
}

.price-table td {
    padding: 12px 20px;
    border-bottom: 1px solid #e5e7eb;
    color: #4a5568;
}

.price-table tr:hover {
    background: #f8f9fa;
}

.price-table tr:last-child td {
    border-bottom: none;
}
</style>
